import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Globe, BookOpen, ShieldCheck, CreditCard, Bot } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-138">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand/10 blur-[120px] rounded-full pointer-events-none" data-id="element-139" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-141">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-border text-brand font-semibold mb-8" data-id="element-142">
            <span className="text-xl" data-id="element-143">🤖</span> SABER-DIGITAL™
          </div>

          <p className="text-brand font-bold tracking-wide uppercase text-sm md:text-base mb-6" data-id="element-144">
            Todo tu dominio de la IA.
            <span className="text-white ml-1" data-id="element-145">Listo. Desde hoy.</span>
          </p>

          <h1 className="text-4xl md:text-6xl font-heading font-bold leading-tight mb-6" data-id="element-146">
            MegaPack IA Listo <br data-id="element-147" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand to-cyan-300" data-id="element-148">
              Combo Completo
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium mb-10 max-w-3xl mx-auto" data-id="element-149">
            Dominá la IA con prompts, flujos de trabajo y plantillas listas para
            usar. De principiante a avanzado, sin improvisar.
          </p>

          {/* Product Mockup */}
          <motion.div className="mb-12" animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-150">
            <img src="https://cdn.magicpatterns.com/uploads/xt1enP6nzRAk6DWR1H7Fah/mock_up_IA_-_Editado.jpg" alt="SABER-DIGITAL MegaPack IA Listo — Combo Completo" className="mx-auto max-w-full w-[700px] drop-shadow-[0_0_40px_rgba(6,182,212,0.2)]" data-id="element-151" />
          </motion.div>

          <div className="flex flex-col items-center gap-4 mb-12" data-id="element-152">
            <CtaButton className="text-xl px-10 py-5" href="#pricing" data-id="element-153">
              <span className="mr-2" data-id="element-154">🤖</span> → QUIERO MI MEGAPACK IA AHORA
            </CtaButton>

            <div className="flex flex-wrap justify-center items-center gap-4 text-sm text-muted mt-2" data-id="element-155">
              <span className="flex items-center gap-1" data-id="element-156">
                <ShieldCheck size={16} className="text-brand" data-id="element-157" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-158">
                <ShieldCheck size={16} className="text-brand" data-id="element-159" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-160">
                <CreditCard size={16} className="text-blue-400" data-id="element-161" /> Tarjeta /
                Transferencia / PayPal
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-surface border border-border rounded-full px-4 py-2 text-sm font-medium" data-id="element-162">
      {icon}
      <span data-id="element-163">{text}</span>
    </div>;
}